// extracted by mini-css-extract-plugin
export var container = "_9k-0";
export var fallback = "_9k-5";
export var fallbackIcon = "_9k-6";
export var hidden = "_9k-2";
export var image = "_9k-3";
export var loaded = "_9k-4";
export var placeholder = "_9k-1";